document.addEventListener("DOMContentLoaded", function () {
  const handleUserInteraction = () => {
    
    const gtagScript = document.createElement("script");
    gtagScript.src = `https://www.googleoptimize.com/optimize.js?id=GTM-W5T3ZCQ`; // Replace with your GTAG ID
    gtagScript.async = true;
    gtagScript.id = "gtag-script";
    document.head.appendChild(gtagScript);

    // Google Tag Manager
    const inlineGTMScript = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-M94KFWD');
    `;
    const inlineGTMScriptObj = document.createElement("script");
    inlineGTMScriptObj.id = "gtag-init";
    inlineGTMScriptObj.textContent = inlineGTMScript;
    document.head.appendChild(inlineGTMScriptObj);

    // Global site tag (gtag.js) - Google Ads: 983524035
    const globalTagScript = document.createElement("script");
    globalTagScript.src = `https://www.googletagmanager.com/gtag/js?id=AW-983524035`;
    globalTagScript.async = true;
    globalTagScript.id = "global-tag-script";
    document.head.appendChild(globalTagScript);

    // Page hiding snippet (recommended)
    const inlineGlobalTagScript = `
      window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'AW-983524035', {'allow_enhanced_conversions': true});
    `;
    const inlineGlobalTagScriptObj = document.createElement("script");
    inlineGlobalTagScriptObj.id = "phs-init";
    inlineGlobalTagScriptObj.textContent = inlineGlobalTagScript;
    document.head.appendChild(inlineGlobalTagScriptObj);

    //HotJar
    const path = window.location.pathname;
    // Temporarily excluded all blogs & CMS pages from recording to capture more sessions for the new design of Zen Sack Classic & Zen One Classic. 
    if (!path.includes('/blogs/') && !path.includes('/pages/')) {
        const inlineHotJarTagScript = `
        (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:536369,hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
            a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `;
        const inlineHotJarTagScriptObj = document.createElement("script");
        inlineHotJarTagScriptObj.id = "hotjar-init";
        inlineHotJarTagScriptObj.textContent = inlineHotJarTagScript;
        document.head.appendChild(inlineHotJarTagScriptObj);
    }

        // Twitter
  //   const inlineTwitterTagScript = `
  //     !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
  // },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',
  // a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
  // twq('config','ocpow');
  //   `;
  //   const inlineTwitterTagScriptObj = document.createElement("script");
  //   inlineTwitterTagScriptObj.id = "twitter-init";
  //   inlineTwitterTagScriptObj.textContent = inlineTwitterTagScript;
  //   document.head.appendChild(inlineTwitterTagScriptObj);

    // Pinterest
    const inlinePintrestTagScript = `
      !function(e){if(!window.pintrk){window.pintrk=function(){window.pintrk.queue.push(
      Array.prototype.slice.call(arguments))};var
      n=window.pintrk;n.queue=[],n.version="3.0";var
      t=document.createElement("script");t.async=!0,t.src=e;var
      r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
	    pintrk('load', '2618752019405');
	    pintrk('page');
    `;
    const inlinePintrestTagScriptObj = document.createElement("script");
    inlinePintrestTagScriptObj.id = "pintrest-init";
    inlinePintrestTagScriptObj.textContent = inlinePintrestTagScript;
    document.head.appendChild(inlinePintrestTagScriptObj);

    // Pinterest Page View
    const inlinePintrestPageViewTagScript = `
      pintrk('track', 'pagevisit');
    `;
    const inlinePintrestPageViewTagScriptObj = document.createElement("script");
    inlinePintrestPageViewTagScriptObj.id = "pintrest-pageview";
    inlinePintrestPageViewTagScriptObj.textContent = inlinePintrestPageViewTagScript;
    document.head.appendChild(inlinePintrestPageViewTagScriptObj);

     // Tiktok
    const inlineTikTokTagScript = `
      !function (w, d, t) {
		  w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++
)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=i+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
		
		  ttq.load('CDPURM3C77U8T5I4MON0');
		  ttq.page();
		}(window, document, 'ttq');
    `;
    const inlineTikTokTagScriptObj = document.createElement("script");
    inlineTikTokTagScriptObj.id = "tiktok-init";
    inlineTikTokTagScriptObj.textContent = inlineTikTokTagScript;
    document.head.appendChild(inlineTikTokTagScriptObj);

    // Smartlook
    const inlineSmartlookTagScript = `
        window.smartlook||(function(d) {
    var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
    var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
    c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
    })(document);
    smartlook('init', '710872238ae904d3889b19b072f98c8d2fad0004', { region: 'eu' });
    `;
    const inlineSmartlookTagScriptObj = document.createElement("script");
    inlineSmartlookTagScriptObj.id = "smartlook-init";
    inlineSmartlookTagScriptObj.textContent = inlineSmartlookTagScript;
    document.head.appendChild(inlineSmartlookTagScriptObj);

    // OpenSend
    const inlineOpenSendScript = `
        !function(e,s){
  (o=s.createElement('script')).src='https://s.opensend.com/os.min.js',o.async=!0,o.setAttribute('ostyp','6311ae17'),o.setAttribute('osid','65E76CCF'),(t=s.getElementsByTagName('script')[0]).parentNode.insertBefore(o,t)
}(window,document);
    `;
    const inlineOpenSendScriptObj = document.createElement("script");
    inlineOpenSendScriptObj.id = "opensend-init";
    inlineOpenSendScriptObj.textContent = inlineOpenSendScript;
    document.head.appendChild(inlineOpenSendScriptObj);

     // Clarity
    const inlineClarityScript = `
         (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "qpgkouupt6");
    `;
    const inlineClarityScriptObj = document.createElement("script");
    inlineClarityScriptObj.id = "clarity-init";
    inlineClarityScriptObj.textContent = inlineClarityScript;
    document.head.appendChild(inlineClarityScriptObj);

    // CustomerLabs Tag
    const inlineCustomerLabsScript = `
        !function(t,e,r,c,a,n,s){t.ClAnalyticsObject=a,t[a]=t[a]||[],t[a].methods=["trackSubmit","trackClick","pageview","identify","track", "trackConsent"],t[a].factory=function(e){return function(){var r=Array.prototype.slice.call(arguments);return r.unshift(e),t[a].push(r),t[a]}};for(var i=0;i<t[a].methods.length;i++){var o=t[a].methods[i];t[a][o]=t[a].factory(o)};n=e.createElement(r),s=e.getElementsByTagName(r)[0],n.async=1,n.crossOrigin="anonymous",n.src=c,s.parentNode.insertBefore(n,s)}(window,document,"script","https://cdn.js.customerlabs.co/cl6254w0oodo6h.js","_cl");_cl.SNIPPET_VERSION="2.0.0"
    `;
    const inlineCustomerLabsScriptObj = document.createElement("script");
    inlineCustomerLabsScriptObj.id = "customer-labs-init";
    inlineCustomerLabsScriptObj.textContent = inlineCustomerLabsScript;
    document.head.appendChild(inlineCustomerLabsScriptObj);
    

    // Remove event listeners after execution
    window.removeEventListener("click", handleUserInteraction);
    window.removeEventListener("scroll", handleUserInteraction);
    window.removeEventListener("keydown", handleUserInteraction);
    window.removeEventListener("mousemove", handleUserInteraction);
    window.removeEventListener("touchstart", handleUserInteraction);
    window.removeEventListener("touchmove", handleUserInteraction);
  };

  // Add event listeners to detect user interaction
  window.addEventListener("click", handleUserInteraction);
  window.addEventListener("scroll", handleUserInteraction);
  window.addEventListener("keydown", handleUserInteraction);
  window.addEventListener("mousemove", handleUserInteraction);
  window.addEventListener("touchstart", handleUserInteraction);
  window.addEventListener("touchmove", handleUserInteraction);

  // Clean up event listeners when no longer needed
  window.addEventListener("beforeunload", () => {
    window.removeEventListener("click", handleUserInteraction);
    window.removeEventListener("scroll", handleUserInteraction);
    window.removeEventListener("keydown", handleUserInteraction);
    window.removeEventListener("mousemove", handleUserInteraction);
    window.removeEventListener("touchstart", handleUserInteraction);
    window.removeEventListener("touchmove", handleUserInteraction);
  });
});